module.exports = __webpack_public_path__ + "static/media/06.0d081f7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/06.jpg
// module id = 568
// module chunks = 0